import { atom } from 'recoil'
import { keyFactory } from 'src/utils/recoil'

const key = keyFactory('auth')

export type ModalState = 'login' | 'signup' | 'forgot'

export const modalOpen = atom({
  key: key('modal-open'),
  default: false,
})

export const modalState = atom<ModalState>({
  key: key('modal-state'),
  default: 'login',
})
